import { css } from 'styled-components'
import { mbSize, Media } from '../../../theme'

export const tableStyle = css`
  .table-wrapper {
    max-width: 100%;
    overflow-x: auto;
    margin-bottom: 48px;
    /* 滚动条样式（与 left-section TableOfContentsWrapper 一致；横向滚动用 height） */
    &::-webkit-scrollbar {
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c8c8c8;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
  table.single {
    margin-bottom: 48px;
    border-collapse: separate !important;
    border: none;
    td {
      border-radius: 10px;
      background: #ffffff;
      border: 1px solid #e6e6e6;
      padding: 24px;
    }
  }
  table:not(.single) {
    border-collapse: separate !important;
    border-spacing: 0;
    border-radius: 10px;
    border: none;
    th,
    td {
      border: 1px solid #e8e8e8;
      height: 60px !important;
      padding: 0 10px !important;
    }
    thead tr:first-child th,
    thead tr:first-child td,
    tbody:first-of-type tr:first-child th,
    tbody:first-of-type tr:first-child td {
      background: #ffefec;
    }
    thead ~ tbody:first-of-type tr:first-child th,
    thead ~ tbody:first-of-type tr:first-child td {
      background: #ffffff;
    }
    thead tr:first-child th:first-child,
    thead tr:first-child td:first-child,
    tbody:first-of-type tr:first-child th:first-child,
    tbody:first-of-type tr:first-child td:first-child {
      border-top-left-radius: 10px;
    }
    thead ~ tbody:first-of-type tr:first-child th:first-child,
    thead ~ tbody:first-of-type tr:first-child td:first-child {
      border-top-left-radius: 0;
    }
    thead tr:first-child th:last-child,
    thead tr:first-child td:last-child,
    tbody:first-of-type tr:first-child th:last-child,
    tbody:first-of-type tr:first-child td:last-child {
      border-top-right-radius: 10px;
    }
    thead ~ tbody:first-of-type tr:first-child th:last-child,
    thead ~ tbody:first-of-type tr:first-child td:last-child {
      border-top-right-radius: 0;
    }
    tbody:last-child tr:last-child th:first-child,
    tbody:last-child tr:last-child td:first-child {
      border-bottom-left-radius: 10px;
    }
    tbody:last-child tr:last-child th:last-child,
    tbody:last-child tr:last-child td:last-child {
      border-bottom-right-radius: 10px;
    }
    th:first-child,
    td:first-child {
      position: sticky;
      left: 0;
      z-index: 1;
      background: #ffffff;
    }
    thead tr:first-child th:first-child,
    thead tr:first-child td:first-child,
    tbody:first-of-type tr:first-child th:first-child,
    tbody:first-of-type tr:first-child td:first-child {
      background: #ffefec;
      z-index: 2;
    }
    thead ~ tbody:first-of-type tr:first-child th:first-child,
    thead ~ tbody:first-of-type tr:first-child td:first-child {
      background: #ffffff;
      z-index: 1;
    }
  }

  ${Media.lessThan(Media.small)} {
    table {
      margin-bottom: ${mbSize(48)};
    }
    table.single {
      td {
        padding: ${mbSize(40)};
      }
    }
    table:not(.single) {
      th,
      td {
        height: ${mbSize(92)} !important;
      }
    }
  }
`
